import DocumentController from './document.controller';

import './document.styles.scss';

export default angular.module('directives.abDocument', [])
  .directive('document', () => {
    'ngInject';

    return {
      controller: DocumentController,
      restrict: 'E',
      replace: true,
      scope: {
        documentId: '=',
      },
      templateUrl: require('./document.template.html'),
    };
  })
  .name;
